import React from 'react';
import { Animated, GestureResponderEvent, Pressable, View, ViewStyle } from 'react-native';
// import { isWeb } from '../../constants/Layout';


interface PressableScaleProps {
  onPress?: ((event: GestureResponderEvent) => void) | null | undefined;
  children: React.ReactNode;
  style?: ViewStyle;
  scaleAnimation: Animated.Value;
}

const PressableScale = ({ children, onPress, style, scaleAnimation }: PressableScaleProps) => {
  const onPressIn = () => {
    Animated.spring(scaleAnimation, {
      toValue: 0.9,
      tension: 200,
      friction: 2,
      useNativeDriver: true,
    }).start();
  };

  const onPressOut = () => {
    Animated.spring(scaleAnimation, {
      toValue: 1,
      tension: 200,
      friction: 3,
      useNativeDriver: true,
    }).start();
  };

  return (
    <View style={{
      alignItems: 'center',
      justifyContent: 'center',

    }}>
      <Pressable onPressIn={onPressIn} onPressOut={onPressOut} onPress={onPress} style={({ hovered }) =>
        [{ ...style }, hovered && { transform: [{ scale: 1.05 }] }]}>
        {children}
      </Pressable>
    </View>
  );
};

export default PressableScale;
